import { gql } from '@apollo/client';

export const GET_WAREHOUSE_LIST = gql`
    query GetWarehouseList {
        warehouseList: getWarehouseListByHubId(hubId: 0) {
            id
            name
            sortingCode
            siteType
            parentSiteId
        }
    }
`;

export interface WarehouseType {
    id: string;
    name: string;
    sortingCode?: string;
    siteType: number;
    parentSiteId: number;
}

export interface GetWarehouseListResponse {
    warehouseList: WarehouseType[];
}

/** 全量仓库列表（id、sortingCode、siteType、parentSiteId） */
export const GET_TMS_WAREHOUSE_LIST = gql`
    query GetTmsWarehouseList {
        warehouses: getWarehouseList {
            id
            sortingCode
            siteType
            parentSiteId
        }
    }
`;

export interface GetTmsWarehouseListResponse {
    warehouses: {
        id: string;
        sortingCode?: string | null;
        siteType: number;
        parentSiteId: string;
    }[];
}

/** TMS 路线/容器等需要 id、sortingCode、siteType、parentSiteId 的仓库选项 */
export interface TmsWarehouseOption {
    id: string;
    sortingCode: string;
    siteType: number;
    parentSiteId: string;
}

